import { render } from "./OTPLoginVerivyPage.vue?vue&type=template&id=7ed35ed9&ts=true"
import script from "./OTPLoginVerivyPage.vue?vue&type=script&lang=ts"
export * from "./OTPLoginVerivyPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Authentication/OTPLoginVerivyPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ed35ed9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ed35ed9', __exports__)) {
    api.reload('7ed35ed9', __exports__)
  }
  
  module.hot.accept("./OTPLoginVerivyPage.vue?vue&type=template&id=7ed35ed9&ts=true", () => {
    api.rerender('7ed35ed9', render)
  })

}


export default __exports__